import Icon from '../components/Icon.vue'

Icon.register({"ribbon":{"width":448,"height":512,"paths":[{"d":"M6.1 444.3C-3.5 455.1-1.4 471.9 10.6 480L79.4 507.9C89.3 514.6 102.7 512.9 110.7 504.1L202.5 402.2 123.3 314.3 6.1 444.3zM441.9 444.3S149.9 119.7 146.5 114.2C161.9 105.8 186.7 96.3 224 96.3S286.1 105.8 301.5 114.2C298.2 119.8 245.5 178.8 245.5 178.8L324.6 266.5 358.8 228.5C387.5 196.6 392.1 149.9 370.2 113L326.5 39.5C322.2 32.3 316.6 26.2 309.7 21.5 269-6.1 182.3-8.2 138.3 21.5 131.4 26.2 125.8 32.3 121.5 39.5L77.9 112.7C76.4 115.2 40.8 174.9 89.4 228.7L337.5 504C345.5 512.9 358.9 514.5 368.8 507.8L437.6 479.9C449.5 471.9 451.6 455.1 441.9 444.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ribbon.js
// module id = ZZ9r
// module chunks = 0